import type { FC } from 'react';
import styled from 'styled-components';
import GreenArrowUp from '../../../../assets/GreenArrowUp.svg';
import RedArrowDown from '../../../../assets/RedArrowDown.svg';
import LineIcon from '../../../../assets/Line.svg';

export const enum TrendType {
  UP = 'up',
  DOWN = 'down',
  FLAT = 'flat',
}

export const BehaviourTrendMap = {
  [TrendType.UP]: {
    backgroundColor: '#ECF8F6',
    color: '#06281E',
    icon: <GreenArrowUp />,
  },
  [TrendType.DOWN]: {
    backgroundColor: '#FFEFEF',
    color: '#933547',
    icon: <RedArrowDown />,
  },
  [TrendType.FLAT]: {
    backgroundColor: '#EEF1F9',
    color: '#596180',
    icon: <LineIcon />,
  },
};

type BehaviourTrendProps = {
  value: number;
  type: TrendType;
};

export const BehaviourTrend: FC<BehaviourTrendProps> = ({ value, type }) => {
  return (
    <BehaviourTrendContainer
      $backgroundColor={BehaviourTrendMap[type].backgroundColor}
      color={BehaviourTrendMap[type].color}
    >
      {BehaviourTrendMap[type].icon}
      <TrendValue>{`${value} %`}</TrendValue>
    </BehaviourTrendContainer>
  );
};

export const BehaviourTrendContainer = styled.div<{ $backgroundColor: string; color: string }>`
  display: flex;
  max-width: 60px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 100px;
  padding: 2px 4px;
  background-color: ${(props) => props.$backgroundColor};
  color: ${(props) => props.color};
`;
export const TrendValue = styled.span``;
